import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root:{

  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  title: {
    color: theme.palette.black.dark,
    fontSize: '22px',
    fontWeight: 600,
  },
  icon: {
    marginRight: '5px'
  },
  selectBlock: {
    height: 'auto',
    width: '100%',
    borderRadius: '4px',
  },
  selectContainer: {
    marginTop: '30px'
  },
  selectTitle: {
    fontSize: '14px',
    color: theme.palette.black.dark,
    fontWeight: 600,
    lineHeight: '130%'
  },
  selectSubTitle: {
    fontSize: '12px',
    color: '#656575',
    margin: '14px 0px'
  },
  selectExisting: {

  },
  selectNew: {

  },
  dividerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  divider: {
    width: '1px',
    height: '100%',
    backgroundColor: theme.palette.grey.grey200
  },
  dividerText: {
    color: theme.palette.grey.grey500,
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '130%',
    margin: '10px 0px'
  },
  selectAutocomplete: {
    borderRadius: "4px",
    border: "1px solid var(--Grey-200, #E2E2EA)",
    background: "white",

    '& .MuiOutlinedInput-root': {
      borderRadius: "unset",
      border: 'none',
      '& fieldset': {
        border: 'none', // removes the TextField border
      },
      '&:hover fieldset': {
        border: 'none',
      },
      '&.Mui-focused fieldset': {
        border: 'none',
      },
    },
  },
  selectOption: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '5px 6px'
  },
  selectName: {
    color: theme.palette.grey.grey700,
    fontSize: '12px',
    fontWeight: 600,
    width: '120px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  selectRef: {
    display: 'block',
    color: theme.palette.grey.grey500,
    fontSize: '12px',
    fontWeight: 500,
    maxWidth: '100px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginLeft: '20px'
  },
  selectDate: {
    color: theme.palette.grey.grey500,
    fontSize: '12px',
    fontWeight: 500,
    marginLeft: 'auto'
  },
  modelSelector: {
    width: '251px',
    background: 'white',
    "& .MuiOutlinedInput-root": {
      border: 0,
    }
  },
  placeholder: {
    color: theme.palette.grey.grey400,
    fontSize: '16px',
    lineHeight: '23px',
    letterSpacing: '0.15px',
  }
}));

export default useStyles;
